import React, { createContext }  from "react";

export const MapCoordContext = createContext(null);